import axios from "axios";
import { API_BASE_PATH } from "../../environment"; // Ensure this exports a valid string
import { toast } from "react-toastify";

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

// === PROMOTIONS ===

const PROMOTIONS_API_URL = `${API_BASE_PATH}/promotions/get_using_empId_department`;

export interface Promotiontype {
  employee_id: string;
  department: string;
  username: string;
}

export const fetchPromotionsByEmpIdAndDepartment = async (
  token: string | null
): Promise<Promotiontype[]> => {
  if (!token) {
    const msg = "Authentication token is missing";
    toast.error(msg);
    console.error("[Promotion API] " + msg);
    throw new Error(msg);
  }

  try {
    const response = await axios.get<Promotiontype[]>(PROMOTIONS_API_URL, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    console.error("[Promotion API] Error fetching data: " + msg);
    throw error;
  }
};

// === DESIGNATIONS ===

const DESIGNATION_API_URL = `${API_BASE_PATH}/designation/`;

interface DesignationApiResponse {
  designation_name: string;
  department_name: string;
  status: string;
  department: {
    department_name: string;
  };
}

export const fetchDesignationNames = async (
  token: string | null
): Promise<string[]> => {
  if (!token) {
    const msg = "Authentication token is missing";
    toast.error(msg);
    console.error("[Designation API] " + msg);
    throw new Error(msg);
  }

  try {
    const response = await axios.get<DesignationApiResponse[]>(
      DESIGNATION_API_URL,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const designationNames = response.data.map((item) => item.designation_name);
    return designationNames;
  } catch (error: any) {
    const msg = extractErrorMessage(error);
    toast.error(msg);
    console.error("[Designation API] Error fetching designations: " + msg);
    throw error;
  }
};
